"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const material_1 = require("@angular/material");
const _4d_mapper_1 = require("4d-mapper");
const app_service_1 = require("../app.service");
const rxjs_1 = require("rxjs");
const forms_1 = require("@angular/forms");
const BaseComponent_1 = require("../BaseComponent");
const router_1 = require("@angular/router");
const application_events_service_1 = require("../../xs/services/events/application-events.service");
class SetupDialog extends BaseComponent_1.BaseComponent {
    constructor(router, snackBar, dialogRef, data, fourD, service, locale, dialog, applicationEvents) {
        super(router, snackBar, dialog);
        this.router = router;
        this.snackBar = snackBar;
        this.dialogRef = dialogRef;
        this.data = data;
        this.fourD = fourD;
        this.service = service;
        this.locale = locale;
        this.dialog = dialog;
        this.selectedIndex = 0;
        this.addressControl = new forms_1.FormControl('', [forms_1.Validators.required]);
        this.netmaskControl = new forms_1.FormControl('', [forms_1.Validators.required]);
        this.gatewayControl = new forms_1.FormControl('', [forms_1.Validators.required]);
        this.invite = { email: null, group: null };
        this.groups = [];
    }
    ngOnDestroy() {
    }
    ngOnInit() {
        // Check network details
        this.checkNetwork();
        // Get user access groups
        this.fourD.activeTeam.accountGroups.queryObservable().subscribe(res => this.groups = res.items);
    }
    uploadFile(event) {
        this.loading = true;
        let fileList = event.target.files;
        if (fileList.length > 0) {
            let file = fileList[0];
            fetch(this.fourD.V.config.host + "/api/Account/" + this.fourD.activeTeam.id + '/image.png', {
                method: 'POST',
                body: file,
                headers: {
                    'Content-type': 'application/binary',
                    Authorization: 'bearer ' + this.service.V.authToken()
                }
            }).then(r => {
                this.loading = false;
                // Reload the img src after file uplaoded to server
                this.imageDirective.updateLink();
            });
        }
        else {
            this.loading = false;
        }
    }
    checkNetwork() {
        this.selectedInterface = null; // reset
        this.loading = true;
        this.service.V.api("/admin/network", "get").subscribe(res => {
            this.networkInterfaces = res;
            // Try to selected the default interface to configure
            this.selectedInterface = res.find(ele => (ele.name.toLowerCase().startsWith("e") && ele.ip4));
            console.log("ENTER this.selectedInterface:", this.selectedInterface);
            this.loading = false;
        }, err => {
            this.loading = false;
        });
    }
    setNetwork(netIf) {
        this.addressControl.setValue(netIf.ip4);
        this.netmaskControl.setValue("");
        this.gatewayControl.setValue("");
    }
    networkSetup(netIf) {
        let loginObs;
        let args = {
            name: netIf.name,
            address: this.addressControl.value,
            netmask: this.netmaskControl.value
        };
        if (this.gatewayControl.value) {
            args["gateway"] = this.gatewayControl.value;
        }
        this.service.V.api("/admin/network", "post", args)
            .subscribe(res => {
            this.loading = false;
            this.openSnackBarSuccess('GENERIC.SUCCESS');
            // Reset to check changes applied
            //this.checkNetwork()
        }, err => {
            this.loading = false;
            this.openSnackBarError(err.message);
        });
    }
    sendInvite() {
        let args = { email: this.invite.email };
        console.log("ENTER args: ", args);
        this.fourD.V.api('/app/Account/' + this.fourD.activeTeam.id + '/invite/' + this.invite.group.id, 'post', args)
            .subscribe(res1 => {
            this.openSnackBarSuccess('SETTINGS.INVITE_SENT');
        }, err => {
            if (err.status == 92002)
                this.openDialog('PLAN.QUOTA', 'PLAN.QUOTA_DESC_USER');
            else
                this.openSnackBarError('ERROR.VASAT', '', err);
        });
    }
    nextStep() {
        if (this.selectedIndex != 3) {
            this.selectedIndex = this.selectedIndex + 1;
        }
        console.log(this.selectedIndex);
    }
    closeDialog() {
        this.dialogRef.close();
    }
}
exports.SetupDialog = SetupDialog;
